import React, { useEffect } from "react";
import { connect } from "react-redux";
import Login from "./components/base/Login";
import "font-awesome/css/font-awesome.min.css";
import "./variables.css";
import Dashboard from "./components/base/Dashboard";
import { useNavigate } from "react-router-dom";
// import Navigation from "./components/navigation";
// import { ActionCreators } from "./components/store/actions/index.js";

function App() {
  var response = JSON.parse(localStorage.getItem("authenticated"));
  const navigate = useNavigate();
  useEffect(() => {
    if (response) {
      navigate("/dashboard");
    }
  }, []);

  return <>{response ? <Dashboard /> : <Login />}</>;
}

export default App;
